"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const InStock = createSVGIcon(
  <>
    <path
      d="M3.428 15.429H1.714a1.143 1.143 0 0 1-1.143-1.143V5.143h14.857v9.143a1.143 1.143 0 0 1-1.142 1.143H12.57M12.907 1.109a1.14 1.14 0 0 0-.969-.537H4.062a1.14 1.14 0 0 0-.97.537L.572 5.143h14.856z"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m5.214 10.664 1.172 1.507a.43.43 0 0 0 .668.01l3.731-4.517"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "In Stock",
  {
    viewBox: "0 0 16 16",
    titleAccess: "In Stock",
    fill: "none",
    className: legacyIconCls(),
  }
);
